import { ONE_MINUTE } from '@gem/services/date-service';

import { storageSessionCredentials } from '../../storage';
import { getPresignedFileUrl } from '../utils/getPresignedFileUrl';
import { isPresignedUrl } from '../utils/isPresignedUrl';
import { loadRemoteStorageCredentials } from './loadRemoteStorageCredentials';

export async function loadPresignedUrl(url: string): Promise<string> {
  const credentials = storageSessionCredentials.get();

  if (!url) {
    return '';
  }

  if (!credentials || !url.includes(credentials.endpoint) || isPresignedUrl(url)) {
    return url;
  }

  const expirationDate = new Date(credentials.expiration).getTime();
  const now = new Date().getTime();
  const expireIn = expirationDate - now;
  if (expireIn < ONE_MINUTE) {
    await loadRemoteStorageCredentials();
  }

  return getPresignedFileUrl(url, credentials);
}
